import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/opel-gebraucht-deutschland/")({
  head: () => routeHead("/de/opel-gebraucht-deutschland/"),
  beforeLoad: () => {
    throw redirect({ href: "/de/cars/opel", statusCode: 301, replace: true });
  },
});
